/* jshint devel:true */
var $ = require('jquery');
var validate = require('jquery-validation');
require('jquery-validation/dist/additional-methods.js');
window.$ = window.jQuery = $;

var placeholder = require('jquery-placeholder'),
	slick = require('slick-carousel-browserify'),
	enquire = require('enquire.js'),
	pickadate = require('pickadate/lib/picker.date'),
	typeahead = require('typeahead.js'),
	matchmedia = require('matchmedia');
window.Bloodhound = require('bloodhound-js');

require('./modules/_polyfills.js'); //Require this first
require('./modules/_init.js');
require('./modules/_autocomplete.js');
require('./modules/_form.js');
require('./modules/_menu.js');
require('./modules/_breadcrumbs.js');
require('./modules/_modal.js');
require('./modules/_tabs.js');
require('./modules/_minsoltid.js');
require('./modules/_embed-responsive.js');
require('./modules/_accordion.js');
require('./modules/_suntime.js');
require('./modules/_page-navigation.js');
require('./modules/_sub-navigation.js');
require('./modules/_uv-index-chart.js');
require('./modules/_uv-index-weekly-overview.js');
require('./modules/_uv-index-map.js');
require('./modules/_uv-index-layout.js');
require('./modules/_expandable-text-block.js');

var ssm = window.ssm || {};

ssm.enhance = function (root) {
	'use strict';

	$('[data-component="menu"]', root).each(function () {
		ssm.menu(this);
	});

	$('[data-component="menu-button"]', root).each(function () {
		var el = document.getElementById(this.getAttribute('aria-controls'));
		if (!el) {
			throw 'Could not find element with id ' + this.getAttribute('aria-controls');
		}

		var menu = ssm.menu(el);
		menu.connectTo(this);
	});

	$('[role="tablist"]', root).each(function () {
		ssm.tabs(this);
		ssm.keyboardNavigableList(this);
	});

	$('[data-component="form-reload"]', root).each(function () {
		ssm.formReload(this);
	});

	$('[data-component="form-toggle-all"]', root).each(function () {
		ssm.formToggleAll(this);
	});

	$('[data-disable-on-all]', root).each(function () {
		ssm.formDisableOnAll(this);
	});

	$('[data-validate]', root).each(function () {
		ssm.formValidate(this);
	});
};

(function () {
	'use strict';

	// Placeholder fix for IE8 and older
	$('input, textarea').placeholder();

	$('.carousel').slick({
		dots: true,
		speed: 500,
		prevArrow:
			'<button type="button" class="slick-prev"><span class="icon icon-carousel-prev"></span><span class="visually-hidden">Föregående</span></button>',
		nextArrow:
			'<button type="button" class="slick-next"><span class="icon icon-carousel-next"></span><span class="visually-hidden">Nästa</span></button>',
		dotsClass: 'carousel-paging cf',
	});
	// FIXME: Is this the correct URL for the live setup?
	var lang = document.documentElement.getAttribute('lang') || 'en';

	var mainMenu = ssm.menu('.header-navigation');
	var breadcrumbs = ssm.breadcrumbs('.breadcrumbs');
	var search = ssm.menu('.search-header', { backdrop: false });

	var searchFilter = $('.search-filter');

	$('.button-filter').click(function () {
		searchFilter.toggle();
		$(this).toggleClass('active');
	});

	enquire.register('screen and (max-width:1280px)', {
		match: function () {
			if (mainMenu) mainMenu.contract();
		},

		unmatch: function () {
			if (mainMenu) mainMenu.reset();
		},

		setup: function () {},

		deferSetup: true,

		destroy: function () {},
	});

	enquire.register('screen and (max-width:640px)', {
		match: function () {
			if (search) search.contract();
			if (breadcrumbs) breadcrumbs.showMobileBreadcrumbs();
		},

		unmatch: function () {
			if (search) search.reset();
			if (breadcrumbs) breadcrumbs.showDesktopBreadcrumbs();
		},

		setup: function () {},

		deferSetup: true,

		destroy: function () {},
	});

	if (mainMenu) mainMenu.connectTo('#primary-navigation');
	if (search) search.connectTo('#button-search');

	// // Enhance all of the components
	$(function () {
		ssm.enhance();
	});

	// Add focus outlines on tab
	document.addEventListener('keydown', function (event) {
		if (event.which === 9) {
			// Tab key
			$('body').addClass('show-focus-outlines');
		}
	});

	// Remove focus outlines on mouse click
	document.addEventListener('click', function (event) {
		if (event.clientX) {
			$('body').removeClass('show-focus-outlines');
		}
	});

	// /* Sorry about this. Really sorry. */
	if (
		!window.Modernizr.inputtypes.date ||
		!/Android|webOS|iPhone|iPad|iPod|BlackBerry|iemobile|Windows Phone|WPDesktop|nok6|noki|Opera Mini/i.test(
			navigator.userAgent
		)
	) {
		$('input[type=date]').each(function (index, element) {
			var $this = $(element);

			$this
				.pickadate({
					monthsFull: [
						'januari',
						'februari',
						'mars',
						'april',
						'maj',
						'juni',
						'juli',
						'augusti',
						'september',
						'oktober',
						'november',
						'december',
					],
					monthsShort: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
					weekdaysFull: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
					weekdaysShort: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],

					today: 'Idag',
					clear: 'Rensa',
					close: 'Stäng',

					min: $this.data('from-min') ? $this.val() : false, // Adds custom min date
					max: $this.data('to-max') ? $this.val() : false, // Adds custom max date

					editable: true,

					firstDay: 1,

					format: 'yyyy-mm-dd',
					formatSubmit: 'yyyy-mm-dd',

					labelMonthNext: 'Nästa månad',
					labelMonthPrev: 'Föregående månad',
					labelMonthSelect: 'Välj månad',
					labelYearSelect: 'Välj år',
				})
				.on('keydown', function (e) {
					if (e.keyCode === 13 /* ENTER */) {
						e.preventDefault();
						var picker = $this.pickadate('picker');
						picker.open();
					}
				})
				.off('focus');
		});
	}
})();

// http://www.456bereastreet.com/archive/201309/responsive_scrollable_tables/
$(window).on('load', function () {
	'use strict';

	// Check all tables. You may need to be more restrictive.
	$('table').each(function () {
		var element = $(this);
		// Create the wrapper element
		var scrollWrapper = $('<div />', {
			class: 'scrollable',
			html: '<div />', // The inner div is needed for styling
		}).insertBefore(element);
		// Store a reference to the wrapper element
		element.data('scrollWrapper', scrollWrapper);
		// Move the scrollable element inside the wrapper element
		element.appendTo(scrollWrapper.find('div'));
		// Check if the element is wider than its parent and thus needs to be scrollable
		if (element.outerWidth() > element.parent().outerWidth()) {
			element.data('scrollWrapper').addClass('has-scroll');
		}
		// When the viewport size is changed, check again if the element needs to be scrollable
		$(window).on('resize orientationchange', function () {
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			} else {
				element.data('scrollWrapper').removeClass('has-scroll');
			}
		});
	});
});

$(document).ready(function () {
	'use strict';

	// Hide typeahead duplicate input field from screen readers
	$('.tt-hint').attr('aria-hidden', 'true');
	// Responsive video
	ssm.video();
});

document.addEventListener('DOMContentLoaded', function () {
	var crisisBanner = document.querySelector('.crisis');
	var mainContent = document.querySelector('#main');

	function updatePadding() {
		if (!crisisBanner || !mainContent) {
			return;
		}
		var bannerHeight = crisisBanner.offsetHeight;
		var shouldApplyPadding = window.matchMedia('(max-width: 640px) and (orientation: portrait)').matches;
		mainContent.style.paddingTop = shouldApplyPadding ? bannerHeight + 'px' : 0;
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			}, wait);
			if (immediate && !timeout) func.apply(context, args);
		};
	}

	window.addEventListener('resize', debounce(updatePadding, 50));
	updatePadding();
});
